import { render, staticRenderFns } from "./SalidaNew.vue?vue&type=template&id=066e0ed2&scoped=true&"
import script from "./SalidaNew.vue?vue&type=script&lang=ts&"
export * from "./SalidaNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e0ed2",
  null
  
)

export default component.exports